import {AlertCircleIcon, CheckCircleIcon} from 'src/components/icon'
import {InputStatusIconWrapper} from 'src/components/input-status-icon/style.ts'
import {Spinner} from 'src/components/spinner/Spinner.tsx'
import {useTheme} from 'styled-components'

interface InputStatusIconProps {
    hasError?: boolean
    touched?: boolean
    isLoading?: boolean
}
export const InputStatusIcon = ({hasError, touched, isLoading}: InputStatusIconProps) => {
    const {palette} = useTheme()

    return (
        <InputStatusIconWrapper $hasError={hasError}>
            {isLoading && <Spinner size={16} fill={palette.neutral['600']} />}
            {hasError && !isLoading && <AlertCircleIcon size={16} data-color />}
            {touched && !hasError && !isLoading && <CheckCircleIcon size={16} data-color />}
        </InputStatusIconWrapper>
    )
}

InputStatusIcon.displayName = 'InputStatusIcon'
